module.exports = __webpack_public_path__ + "static/media/Mara.8dd614e3.jpg";